import { CryptoBadge } from "~/v2/components/common/cryptoBadge";
import { CryptoPerpBadge } from "~/v2/components/common/cryptoPerpBadge";

export const getCryptoBadge = (asset_class: string) => {
  if (asset_class === "crypto") {
    return <CryptoBadge />;
  }

  if (asset_class === "crypto_perp") {
    return <CryptoPerpBadge />;
  }

  return null;
};
